"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = closeModal;
exports.showModal = showModal;

var _actions = require("./actions");

function closeModal(name, config) {
  return {
    config: config,
    name: name,
    type: _actions.CLOSE_MODAL
  };
}

function showModal(name, element, config) {
  return {
    config: config,
    element: element,
    name: name,
    type: _actions.SHOW_MODAL
  };
}